import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, RouteName } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl, RestoreReportExpandedRows } from '@mews-commander/modules/src/modules/app';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const { pathname, search } = Route.useMatch();

    return (
        <>
            <RestoreReportExpandedRows reportName={RouteName.AccountingReportIndex} rowClassPrefix="item" />
            <BackendPage url={getBackendPageUrl({ pathname, search })} routeName={RouteName.AccountingReportIndex} />
        </>
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/AccountingReport/Index/')({
    component: Component,
    staticData: {
        routeName: RouteName.AccountingReportIndex,
        owner: MewsTeam.Accounting,
        type: RouteType.Backend,
        guideLink: createGuideLink(ArticlePath.AccountingReport),
    },
});
